<template>
  <button
    :disabled="disabled"
    @click="() => clickFunc()"
    class="modern-button"
    :class="{
      'large': btnSize.toLowerCase() === 'large',
      'small': btnSize.toLowerCase() === 'small',
      'extra-small': btnSize.toLowerCase() === 'extra-small',
      'border': showBorder,
    }"
  >
    {{ btnText }}
  </button>
</template>

<script>

export default {
  name: 'ModernButton',
  props: {
    btnText: String,
    clickFunc: Function,
    disabled: {
      type: Boolean,
      default: false
    },

    // allows us to inject button color if we want another color
    backgroundColor: {
      type: String,
      default: '#D5E8D4',
    },
    
    // allows us to inject hover color if we want something differed
    hoverColor: {
      type: String,
      default:'#C3B091'
    },

    hoverFontColor: {
      type: String,
      default: 'black'
    },

    // to allow for smaller button sizes
    btnSize: {
      type: String,
      default: 'large',
    },

    // controlls border of button
    showBorder: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    size() {
      return this.btnSize.toLowerCase();
    }
  },
  mounted() {
    this.$el.style.setProperty('--background-color', this.backgroundColor);
    this.$el.style.setProperty('--hover-color', this.hoverColor);
    this.$el.style.setProperty('--hover-font-color', this.hoverFontColor);
  }
}
</script>

<style scoped>

/* :root {
  --background-color: #D5E8D4;   
} */

/* Modern button styling */
.modern-button {
  
  font-weight: bold;
  color: black;
  background-color: var(--background-color);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all .3s;
}

.large {
  padding: 12px 24px;
  font-size: 16px;
}

.small {
  padding: 6px 12px;
  font-size: 14px;
}

.extra-small {
  padding: 2px 6px;
  font-size: 14px;
}

.border {
  border: 1px solid black;
}

.modern-button:disabled {
  background-color: gray;
  color: #fff;
  cursor: default !important;
  margin: .25rem;
}

/* Hover effect */
.modern-button:hover:not(:disabled) {
  background-color: var(--hover-color);
  color: var(--hover-font-color);
}



</style>